import { useEffect, useState } from 'react';
import { api } from './api';

// Names for the Salesperson dropdown, straight from the user accounts — a
// salesperson who signs up and gets approved shows up here with no admin step.
// Module-level cache so every row on the dashboard shares one fetch.
let _cache = null;
const _listeners = new Set();

export function useSalespeople() {
  const [names, setNames] = useState(_cache || []);

  useEffect(() => {
    _listeners.add(setNames);
    if (!_cache) {
      api.salespeople()
        .then((rows) => { _cache = rows; _listeners.forEach((fn) => fn(rows)); })
        .catch((e) => console.error('salespeople load:', e));
    }
    return () => { _listeners.delete(setNames); };
  }, []);

  return names;
}

// The dropdown must never silently drop a name typed before this existed, so
// the car's current value is always an option even if it has no account.
export function withCurrent(names, current) {
  const c = String(current || '').trim();
  if (!c) return names;
  return names.some((n) => n.toLowerCase() === c.toLowerCase()) ? names : [c, ...names];
}
